import React from 'react'
import { connect } from 'react-redux'
import Parcels from '../../../../../lib/api/parcels'
import LandownerResult from './landowner-result'

class LandownerSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ownerName: '',
      ownerState: '',
      states: [],
      searchPending: false,
      searchResults: [],
      activeId: 0,
      poly: null,
      errors: []
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const token = this.props.auth.token
    const center = this.props.map?.getCenter?.()
    Parcels.getStates(token).then(states => {
      this.setState({ states })
      if (center) {
        Parcels.getStateByCoordinates(center.lat(), center.lng(), token)
          .then(stateInfo => {
            const abbr = stateInfo?.abbreviation
            const match = abbr && states.find(s => s.abbreviation?.toUpperCase() === abbr.toUpperCase())
            if (match) this.setState({ ownerState: match.abbreviation })
          })
          .catch(() => {})
      }
    })
  }

  componentWillUnmount() {
    if (this.state.poly !== null) {
      this.state.poly.setMap(null)
    }
  }

  handleChange(e) {
    const id = e.target.id,
      value = e.target.value
    this.setState({ [id]: value }, () => {
      if (this.state.ownerState && this.state.ownerName.length > 2 && !this.state.searchPending) {
        this.setState({ searchPending: true }, () => {
          this.searchParcels()
        })
      }
    })
  }

  searchParcels() {
    const center = this.props.map.getCenter(),
      latitude = center.lat(),
      longitude = center.lng(),
      token = this.props.auth.token,
      searchProps = Object.assign({ latitude, longitude, token }, this.state),
      errors = []

    Parcels.search(searchProps)
      .then(res => {
        if (!res.length > 0) {
          errors.push(`No results found for ${this.state.ownerName} and ${this.state.ownerState}.`)
        }
        const searchPending = this.state.ownerName !== searchProps.ownerName
        res.forEach(parcel => {
          const parcelCenter = new google.maps.LatLng({ lat: parcel.center.latitude, lng: parcel.center.longitude }),
            scaler = this.props.measureUnit === 'metric' ? 1000 : 1609.344,
            label = this.props.measureUnit === 'metric' ? 'km.' : 'mi.',
            dist = google.maps.geometry.spherical.computeDistanceBetween(center, parcelCenter) / scaler,
            distParced = Math.round(dist * 10) / 10,
            distanceString = `${distParced} ${label}`

          parcel.distance = distanceString
        })
        this.setState({ searchResults: res, searchPending, errors }, () => {
          if (searchPending) {
            this.searchParcels()
          }
        })
      })
      .catch(err => {
        if (err.status == 500 || err.status == 504 || err.status == undefined) {
          errors.push(`Search for ${this.state.ownerName} and ${this.state.ownerState} timed out. Please try a more specific search.`)
          const searchPending = this.state.ownerName !== searchProps.ownerName
          this.setState({ searchResults: [], searchPending, errors }, () => {
            if (searchPending) {
              this.searchParcels()
            }
          })
          return
        }
        this.setState({ searchPending: false, errors })
      })
  }

  handleParcelClick(center, gid) {
    const lat = center.latitude,
      lng = center.longitude,
      coords = new google.maps.LatLng(lat, lng)
    this.props.map.setZoom(18)
    this.props.map.setCenter(coords)
    if (this.state.poly === null || this.state.activeId !== gid) {
      if (this.state.poly !== null) {
        this.state.poly.setMap(null)
      }
      Parcels.getExtent(this.props.auth.token, gid)
        .then(extents => {
          const cleaned = extents.replace('POLYGON((', '').replace('))', '');

          // Split into coordinate pairs
          const coords = cleaned.split(',');

          // Optional: remove last point if it is a repeat of the first (closing the polygon)
          const trimmedCoords = coords.slice(0, coords.length - 1);

          // Convert to LatLng objects
          const latLngs = trimmedCoords.map(coord => {
            const [lng, lat] = coord.trim().split(' ').map(Number);
            return new google.maps.LatLng(lat, lng);
          });

          let map = this.props.map,
            poly = new google.maps.Polygon({
              paths: latLngs,
              strokeColor: 'red',
              strokeOpacity: 1,
              strokeWeight: 2
            })
          poly.setMap(map)
          this.setState({ poly, activeId: gid })
        })
        .catch(err => console.error(err))
    }
  }

  handleClearSearch = () => {
    this.setState({ ownerName: '' })
  }

  render() {
    const { searchPending, ownerName } = this.state
    return (
      <div className='search-content-container'>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          {/* <div style={{ display: 'flex' }}>
            <i className='material-icons'
              style={{ fontSize: '18px', verticalAlign: 'middle', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >search</i>
            <input
              id='ownerName'
              type='search'
              className='search-input-full'
              placeholder='Owner (Last First)'
              onChange={this.handleChange}
              style={{ width: '75%' }}
            >
            </input>
          </div> 
          <div className='search-filter-container'>
            <div className='search-input-container'>
              <input
                id='ownerName'
                className='search-style'
                type='search'
                placeholder="Search Owner"
                // value={this.state.searchQuery}
                onChange={this.handleChange}
                style={{ height: '104%', }}
              />
              <img
                className='search-icon'
                src='../../../asset/Search_Solid_589500_ldpi.png'
                alt='search'
              // onClick={this.handleSearch}
              />
            </div> 
          </div>*/}

          <div style={{ width: 340, display: 'flex' }}>
            <div className='search-filter-container' style={{ width: 168 }}>
              <div className='search-input-container'>
                <input
                  className='search-style'
                  placeholder='Owner (Last First)'
                  id="ownerName"
                  value={ownerName}
                  type="text"
                  onChange={this.handleChange}
                  style={{ width: '98%', height: 42, outline: 'none' /* Remove default outline */ }}
                  onFocus={() => this.setState({ focus: true })}
                />
                {ownerName == '' ?
                  <img
                    className='search-icon'
                    src='../../../asset/Search_Solid_white_ldpi.png'
                    alt='search'
                    style={{ right: 10 }}
                  /> : <img
                    className='clear-icon'
                    src='../../../asset/Close-X_Thin_FFFFFF_ldpi.png'
                    alt='clear'
                    style={{ right: 10, width: 16 }}
                    onClick={this.handleClearSearch}
                  />
                }
              </div>
            </div>
            <div style={{ width: 168 }}>
              <select
                id='ownerState'
                className='search-style'
                value={this.state.ownerState}
                onChange={this.handleChange}
                style={{ width: '98%', height: 42, marginLeft: 5, outline: 'none' }}
              >
                <option value="">--State--</option>
                {this.state.states.map(state => {
                  return (
                    <option key={state.abbreviation} value={state.abbreviation}>{state.name}</option>
                  )
                })
                }
              </select>
            </div>
          </div>

        </div>
        <div
          // style={{display: 'flex',   flexDirection: 'column',   overflowY: 'auto',   height: 'calc(100vh - 210px)' }}
          className='google-landowner-search-result-container'
        >
          {
            searchPending ? (<div className='loading-spinner horizontal-center'></div>) : null
          }
          {
            this.state.errors.map((err, i) => {
              return (
                <div
                  key={i}
                  style={{
                    color: 'red'
                  }}>
                  {err}
                </div>
              )
            })
          }
          {this.state.searchResults.map((property, idx) => {
            return <LandownerResult
              key={idx}
              property={property}
              map={this.props.map}
              activeId={this.state.activeId}
              handleParcelClick={this.handleParcelClick.bind(this)}
            />
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  map: state.mapReference()
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(LandownerSearch)